import { useTranslation } from "react-i18next";
import CheckboxInput from "../../../components/inputs/CheckboxInput";
import { SYSTEM_DETAIL_CODES } from "../../../constants/common";
import { useGetAllSystemDetailCodesDropdown } from "../../../hooks/common/query";

interface RequestedServicesCardProps {
    requestedServicesIds: number[];
    setRequestedServicesIds: React.Dispatch<React.SetStateAction<number[]>>;
    isFieldsDisabled: boolean;
}

const RequestedServicesCard = ({
    requestedServicesIds,
    setRequestedServicesIds,
    isFieldsDisabled
}: RequestedServicesCardProps) => {
    const { t, i18n } = useTranslation();

    const { data: requestedServices } = useGetAllSystemDetailCodesDropdown({
        encryptedId: SYSTEM_DETAIL_CODES.OFFICE_ACCESS_AUTHORIZATION_REQUESTED_SERVICES,
    });

    return (
        <div className="flex flex-col gap-1">
            <p className="text-sm font-normal">
                {t("requestedService")}
            </p>

            <div className="flex items-center flex-wrap gap-x-10 gap-y-3">
                {requestedServices?.map((item: any) => {
                    const id = item.n_DetailedCode;
                    const isChecked = requestedServicesIds?.includes(id);

                    return (
                        <div key={id}>
                            <CheckboxInput
                                key={`service-${id}`}
                                id={`service-${id}`}
                                label={i18n.language === "en" ? item.s_Desc_E : item.s_Desc_A}
                                checked={isChecked}
                                setChecked={() => {
                                    setRequestedServicesIds(prev =>
                                        isChecked
                                            ? prev.filter(serviceId => serviceId !== id)
                                            : [...prev, id]
                                    );
                                }}
                                readOnly={isFieldsDisabled}
                            />
                        </div>
                    );
                })}
            </div>
        </div>
    )
}

export default RequestedServicesCard
